import i18next from "i18next";
import * as formationsServices from "../../services/formationsServices";
import { useEffect, useState } from "react";
import Autocomplete from "../../components/Autocomplete";
import MultiSelect from "../../components/MultiSelect";
import useDebouncedFunction from "../../hooks/useDebouncedFunction";

interface FormationsSelectProps {
	options?: any;
	value?: any;
	showValue?: any;
	onChange?: any;
	error?: any;
	className?: string;
	multiple?: boolean;
	required?: boolean;
}

const FormationSelect = ({ multiple, value, showValue, onChange, error, required }: FormationsSelectProps) => {
	const [formations, setFormations] = useState<any>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!showValue) {
			handleChangeSearch({ target: { value: "" } });
		}
	}, [showValue]);

	const handleChangeSearch = async (e: any) => {
		const value = e?.target?.value ?? "";

		setLoading(true);
		var formations = await formationsServices.search({ skip: 0, limit: 10, search: value });
		formations = formations.result.map((formation) => ({
			label: formation.name,
			value: formation,
			...formation,
		}));
		setFormations(formations);
		setLoading(false);
	};

	const debouncedSearch = useDebouncedFunction(handleChangeSearch);

	if (multiple)
		return (
			<MultiSelect
				options={formations.filter((g) => !value.map((g) => g.id).includes(g.id))}
				placeholder={i18next.t("entity-search", { entity: i18next.t("Formation") })}
				datatestid={"search-formation-input"}
				label={i18next.t("formations")}
				value={value}
				onInputChange={(e) => {
					setLoading(true);
					debouncedSearch(e);
				}}
				renderValue={(value) => <div>{value.map(({ name }) => name).join(", ")}</div>}
				showValue={showValue}
				onChange={onChange}
				error={error}
				loading={loading}
				required={required}
			/>
		);

	return (
		<Autocomplete
			error={error}
			className="mt-3"
			id="formation"
			onInputChange={(e) => {
				setLoading(true);
				debouncedSearch(e);
			}}
			options={formations}
			datatestid={"search-formation-input"}
			onChange={onChange}
			placeholder={i18next.t("entity-search", { entity: i18next.t("Formation") })}
			label={i18next.t("formation")}
			value={value}
			showValue={showValue}
			renderValue={(value) => <div>{value.name}</div>}
			loading={loading}
			required={required}
		/>
	);
};

export default FormationSelect;
